export enum AuthConstants {
    name = 'auth'
}

export type AuthState = {
    token: string | null
};
